import React from 'react';
const NotFound = (props) => {
  return (
    <div>
    </div>
  )
}

export default NotFound;
